export default "__VITE_ASSET__1f0f23ee__"